import { useQuery } from 'data-fetching-client';
import { APP_DETAILS_PREVIEW_QUERY } from '../queries/appDetailsPreviewQuery';
export default function useDetailsPreview({
  appContext,
  slug,
  skip,
  language,
  onDetailsCompleted
}) {
  const {
    data: detailsPreviewData,
    loading: detailsPreviewLoading,
    error: detailsPreviewError
  } = useQuery(APP_DETAILS_PREVIEW_QUERY, {
    variables: {
      slug,
      appContext,
      language
    },
    onCompleted: onDetailsCompleted,
    skip
  });
  return {
    detailsPreviewData,
    detailsPreviewLoading,
    detailsPreviewError
  };
}